'use client';

import { useSyncExternalStore } from 'react';
import { useIsMobileOverride } from '@jlg-website/editor';

const LG_BREAKPOINT_PX = 1024;

const listeners = new Set<() => void>();
let containerWidth = 0;
let observer: ResizeObserver | null = null;

function initObserver() {
  if (typeof window === 'undefined' || observer) return;

  containerWidth = document.body.getBoundingClientRect().width;

  observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const size = entry.contentBoxSize[0];
      containerWidth = size ? size.inlineSize : entry.contentRect.width;
    }
    listeners.forEach((cb) => cb());
  });

  observer.observe(document.body);
}

function subscribe(callback: () => void): () => void {
  initObserver();
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot(): boolean {
  return containerWidth < LG_BREAKPOINT_PX;
}

export function useIsMobile(initialValue: boolean = false): boolean {
  const override = useIsMobileOverride();
  const storeValue = useSyncExternalStore(subscribe, getSnapshot, () => initialValue);
  return override ?? storeValue;
}
